import type { PlcManufacturerCodeLibrary } from "./types";

export const unitronicsCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "unitronics",
  manufacturer_name: "Unitronics",
  codes: [
    {
      id: "unitronics-io-10-low-supply",
      manufacturer_id: "unitronics",
      series_id: "unitronics-unistream",
      model: null,
      code: "0x10",
      code_type: "I/O Status",
      title_ar: "فولت تغذية I/O واطي أو مفقود",
      description_ar: "قيمة IO - Status = 0x10 ببعض Uni-COM I/O modules تعني أن Supply Voltage واطي أو مفقود.",
      symptoms: ["0x10", "I/O ما يشتغل طبيعي"],
      causes: ["فولت التغذية واطي", "تغذية الموديول مفقودة"],
      checks: [
        {
          step: 1,
          action: "افحص تغذية الموديول حسب مواصفاته.",
          expected: "الفولت صحيح وثابت.",
          faulty: "الفولت واطي أو مفقود.",
        }
      ],
      solutions: ["صحح مصدر التغذية والربطات.", "افحص الحماية والفيوز المرتبط."],
      severity: "عالية",
      source_title: "Unitronics UniLogic Help - I/O Modules: Status and Error Messages",
      source_section: "IO Status 0x10 Supply voltage is low or missing",
      keywords: ["Unitronics", "UniStream", "0x10", "supply voltage"],
    },
    {
      id: "unitronics-io-20-config-mismatch",
      manufacturer_id: "unitronics",
      series_id: "unitronics-unistream",
      model: null,
      code: "0x20",
      code_type: "I/O Status",
      title_ar: "I/O Configuration Mismatch",
      description_ar: "قيمة IO - Status = 0x20 تعني أن Hardware Configuration ما يطابق الـI/O الفعلي.",
      symptoms: ["0x20", "I/O configuration mismatch"],
      causes: ["موديل I/O مختلف", "عدد أو ترتيب I/O مختلف عن المشروع"],
      checks: [
        {
          step: 1,
          action: "قارن Hardware Configuration بالـI/O المركب فعلياً.",
          expected: "النوع والعدد والترتيب مطابق.",
          faulty: "أكو اختلاف بالموديولات.",
        }
      ],
      solutions: ["صحح المشروع أو الهاردوير حتى يتطابقن.", "أعد initialization بعد التصحيح حسب الإجراء الصحيح."],
      severity: "عالية",
      source_title: "Unitronics UniLogic Help - I/O Modules: Status and Error Messages",
      source_section: "IO Status 0x20 Configuration Mismatch",
      keywords: ["Unitronics", "UniStream", "0x20", "configuration mismatch"],
    },
    {
      id: "unitronics-io-08-short",
      manufacturer_id: "unitronics",
      series_id: "unitronics-unistream",
      model: null,
      code: "0x08",
      code_type: "I/O Status",
      title_ar: "Short-circuit detected",
      description_ar: "بمخرجات UniStream المحددة، 0x08 يعني اكتشاف شورت.",
      symptoms: ["0x08", "الخرج ما يشتغل أو يدخل حماية"],
      causes: ["شورت بالحمل أو الأسلاك", "توصيل خرج غلط"],
      checks: [
        {
          step: 1,
          action: "اعزل التغذية وافحص الحمل والأسلاك قبل إعادة التشغيل.",
          expected: "ماكو شورت.",
          faulty: "مقاومة/توصيل يدل على قصر.",
        }
      ],
      solutions: ["صلح الشورت قبل Reset.", "افحص الموديول إذا بقى الخطأ بعد فصل الحمل."],
      severity: "حرجة",
      source_title: "Unitronics UniLogic Help - I/O Modules: Status and Error Messages",
      source_section: "IO Status 0x08 Short-circuit detected",
      keywords: ["Unitronics", "UniStream", "0x08", "short circuit"],
    },
    {
      id: "unitronics-input-40-sensor-disconnected",
      manufacturer_id: "unitronics",
      series_id: "unitronics-unistream",
      model: null,
      code: "0x40",
      code_type: "Input Channel Status",
      title_ar: "Sensor Disconnected",
      description_ar: "قيمة channel status = 0x40 على موديولات الإدخال المحددة تعني Sensor Disconnected.",
      symptoms: ["0x40", "القناة ما تقرا الحساس"],
      causes: ["الحساس مفصول", "سلك الحساس مقطوع أو ربطه ضعيف"],
      checks: [
        {
          step: 1,
          action: "افحص الحساس والأسلاك بعد تأمين العملية.",
          expected: "الدائرة متصلة والقراءة طبيعية.",
          faulty: "الحساس أو السلك مفتوح.",
        }
      ],
      solutions: ["أعد ربط أو بدل الحساس/السلك.", "تأكد من نوع الحساس وإعداد القناة."],
      severity: "عالية",
      source_title: "Unitronics UniLogic Help - I/O Modules: Status and Error Messages",
      source_section: "Input Channel Status 0x40 Sensor Disconnected",
      keywords: ["Unitronics", "UniStream", "0x40", "sensor disconnected"],
    },  ],
};
